import React from 'react';

import formatter from '../../utilities/formatter';

const UnsoldQueueItem = ({
    item,
    editItem,
}) => {

    function updateItem({ target: { name, checked } }) {
        const currentData = { ...item };
        currentData[name] = checked;
        editItem(currentData);
    }

    return (
        <tr>
            <td>{item.customerFirstName + ' ' + item.customerLastName}</td>
            <td>{formatter.date(item.proposalDate)}</td>
            <td className="text-center">
                {item.day7FollowUp !== null ? formatter.date(item.day7FollowUp) :
                    (
                        <label className="custom-control custom-checkbox d-inline-flex mb-0">
                            <input type="checkbox" className="custom-control-input" name="sendDay7FollowUp"
                                checked={item.sendDay7FollowUp}
                                onChange={(e) => updateItem(e)}
                            />
                            <span className="custom-control-label">&nbsp;</span>
                        </label>
                    )}
            </td>
            <td className="text-center">
                {item.day30FollowUp !== null ? formatter.date(item.day30FollowUp) :
                    (
                    <label className="custom-control custom-checkbox d-inline-flex mb-0">
                        <input type="checkbox" className="custom-control-input" name="sendDay30FollowUp"
                            checked={item.sendDay30FollowUp}
                            onChange={(e) => updateItem(e)}
                        />
                        <span className="custom-control-label">&nbsp;</span>
                    </label>
                )}
            </td>
        </tr>
    );
}

export default UnsoldQueueItem;